<template>
	<div id="app">
		<div class="load" v-loading="true" v-if="$store.state.app_config_load"></div>
		<el-dialog :title="$store.state.pwd_exp_check?$store.state.pwd_exp_check.msg:''" :visible.sync="is_expire" :before-close="before_close" :close-on-press-escape="false">
			<el-form :model="ruleForm" :rules="pwdRules" ref="ruleForm">
				<el-form-item label="身份证" prop="idcardInput" :label-width="formLabelWidth">
					<el-input v-model="ruleForm.idcardInput" autocomplete="off" placeholder="暂无填写"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="pass" :label-width="formLabelWidth">
					<el-input v-model="ruleForm.pass" type="password" show-password autocomplete="off" placeholder="暂无填写"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass" :label-width="formLabelWidth" style="position: relative;">
					<el-input v-model="ruleForm.checkPass" type="password" show-password autocomplete="off" placeholder="暂无填写"
					 @paste.native.capture.prevent="false"></el-input>
					<div class="tip">新密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
		<template v-if="muban_bol">
			<el-container id="muban" @click.native.stop="qiHide()">
				<el-header height="initial">
					<component v-bind:is="headCom" @swmuban="swmubanFn($event)"></component>
				</el-header>
				<el-row v-bind:style="{minHeight: Height+'px'}" type="flex" justify="center">
					<el-col :span="16" class="center_content_box">
						<router-view v-if="isRouterAlive" @jump="jumpFn($event)" @swmuban="swmubanFn($event)" @chMinHeight="chMinHeightFn($event)" class="rightBox"></router-view>
					</el-col>
				</el-row>
				<!-- <component v-bind:is="course"></component> -->
				<component v-bind:is="footerCom"></component>
			</el-container>
		</template>
		<template v-else>
			<router-view @jump="jumpFn($event)" @swmuban="swmubanFn($event)" :muban_bol="muban_bol"></router-view>
		</template>
	</div>
</template>
<script>
import temp_change from './static/js/template/temp_change';
import headView from "./components/head.vue";					//顶部
import footerView from "./components/footer.vue";					//底部
import  './static/icon/iconfont.js';
export default {
	name: 'App'
	,provide () {
		return {
			reload: this.reload
		}
	}
	,data () {
		var validatePass = (rule, value, callback) => {
			// console.log(value);
			let pwdReg = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8}');
			if (value === '' || value === undefined) {
				callback(new Error('请输入密码'));
			} else if (!pwdReg.test(value)) {
				callback(new Error('密码至少包含字母、数字、特殊字符各1位,总长度8位及以上!'));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			// console.log(value);
			if (value === '' || value === undefined) {
				callback(new Error('请再次输入密码'));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		return {
			headCom:"headView"
			,footerCom:"footerView"
			,muban_bol:false
			,Height:100
			,isRouterAlive: true,
			formLabelWidth:'120px',
			ruleForm:{
				idcardInput:'',
				pass:'',
				checkPass:''
			},
			pwdRules:{
				//required：是否必填，message错误提示内容，trigger触发方式
				idcardInput: [
					{ required: true, message: '请输入身份证号', trigger: 'blur' },
				],
				pass: [
					// { required: true, message: '请输入新密码', trigger: 'blur' },
					{ validator: validatePass, required: true, trigger: 'blur' },
				],
				checkPass: [
					// { required: true, message: '请再次输入密码', trigger: 'blur' },
            		{ validator: validatePass2, required: true, trigger: 'blur' },
				],
			},
			dialogFormVisible:false,
			dialog_title:''
		}
	}
	,created:function(){
		var token=this.$cookies.get("token"),
			that = this


		if (parseInt(window.location.href.indexOf("/web/user_detail")) > 1) {
			// console.log(6);
			
			return false
		}
		// 进入直播页不跳转
		if(this.$store.state.visitor){
			this.muban_bol=true;
			return false
		}

		if(token){
			this.muban_bol=true;
		}else if(window.location.href.indexOf("/web/login") > 1){
			return false
		}
		
		// console.log(66);
		
		//选课中心
		// if (window.location.href.indexOf("/web/course_selection") > 1) {
		// 	return false
		// }
		// console.log(6666);
		this.$store.dispatch('get_identity_list').then(res=>{
			// console.log(res);
			if (res.length>=1) {
				// //获取用户身份列表
				this.$selfjs.getIdentityCallFn(this,function(resData){
					let identity = parseInt(that.$cookies.get("identity"))
					//获取用户数据
					that.$selfjs.getUserCallFn(that,function(userData){
						identity = userData.identity[0].id
						let defaObj = resData[0]
						for(let i=0;i<resData.length;i++){
							if(resData[i].id == identity){
								defaObj = resData[i]
							}
						}
						that.$selfjs.idswitch(that,defaObj)
					})
				})
			}
		})
		
		
	}
	,mounted:function(){
		var os = function (){
			var ua = navigator.userAgent,
			isWindowsPhone = /(?:Windows Phone)/.test(ua),
			isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
			isAndroid = /(?:Android)/.test(ua),
			isFireFox = /(?:Firefox)/.test(ua),
			isChrome = /(?:Chrome|CriOS)/.test(ua),
			isTablet = /(?:iPad|PlayBook)/.test(ua) || /(?:Tablet)/.test(ua),
			isPhone = /(?:iPhone)/.test(ua) && !isTablet,
			isPhoneOpenHarmony = /(?:Phone; OpenHarmony)/.test(ua),
			isPc = !isPhone && !isAndroid && !isSymbian && !isSymbian;
			return {
				isTablet: isTablet,
				isPhone: isPhone,
				isAndroid: isAndroid,
				isPhoneOpenHarmony,
				isPc: isPc
			};
		}();
		//设置学校LOGO
		let cookschool_logo = this.$cookies.get("school_logo");
		if(cookschool_logo){
			this.$store.commit("change_vuex",{
				key:"school_logo",
				value:cookschool_logo
			})
		}
		//安卓、苹果、平板、鸿蒙手机的UA都进入wap
		if (os.isAndroid || os.isPhone || os.isTablet || os.isPhoneOpenHarmony) {
			let live_id = this.$selfjs.getParamString('live_id')
				,room_num = this.$selfjs.getParamString('room_num')
			// 跳转到手机版直播页面
			if(live_id && room_num){
				let id = this.$selfjs.getParamString('id')
				window.location.href = `/wap/#/pages/live/room?id=${id}&live_id=${live_id}&room_num=${room_num}`
				return false
			}
			window.location.href = '/wap/#'
		}
		var that=this
		//动态设置内容高度 让footer始终居底   header+footer的高度是233
		this.Height = document.documentElement.clientHeight - 188;
	　　//监听浏览器窗口变化　
		window.onresize = ()=> {
			that.Height = document.documentElement.clientHeight -188
		}
		let client_type = this.$selfjs.getParamString('client-type') || localStorage.getItem('client_type')
		if(client_type){
			localStorage.setItem('client_type', client_type)
		}else{
			localStorage.setItem('client_type', 'PC')
		}
		// that.$store.dispatch('get_app_config').then(res=>{
		// 	res.platform_code = "platform.en_degree"
		// 	console.log('3'+res.platform_code);
        // 	switch(res.platform_code){
		// 		case "xuexi.qsxueli.com":
		// 			// that.$store.commit("research_institute", false)
		// 			temp_change.xuexi_qsxueli()
		// 			break;
		// 		case "platform.dyy":
		// 			that.$store.commit("change_vuex",{
		// 				key: "titleAfter",
		// 				value: ' - 电子科技大学广东信息工程研究院 - 专业技术人员继续教育网络平台'
		// 			})
		// 			// that.$store.commit("research_institute", true)
		// 			temp_change.dyy_xuexi_qsxueli()
		// 			break;
		// 		case "platform.en_degree":
		// 			that.$store.commit("change_vuex",{
		// 				key: "titleAfter",
		// 				value: ' - 学业水平综合培训考试系统'
		// 			})
		// 			temp_change.en_degree_qsxueli()
		// 			break;
		// 	}
		// })
	}
	,methods:{
		jumpFn:function(args){
			// console.log(args);
			this.$router.push({
				path: args[0],
				name: args[1],
				query: args[2],
				params: args[3]
			})
		}
		,swmubanFn:function(res){
			// console.log(this.muban_bol);
			this.muban_bol=res;
		}
		,chMinHeightFn:function(res){
			this.Height=res;
		}
		//隐藏学期
		,qiHide(){
			this.$store.commit("qiFocus","")
		}
		// 页面刷新方法
		,reload () {
			this.isRouterAlive = false
			this.$nextTick(function () {
				this.isRouterAlive = true
			})
		},
		// 修改密码
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					var token=this.$cookies.get("token")
						,that=this
					const url = this.global.serverSrc+this.global.qianzui+'/password/reset';
					// return false
					//发送修改密码请求
					this.$ajax.post(url,
						that.$qs.stringify({
							mobile:that.ruleForm.idcardInput
							,password: that.$selfjs.getAES(that.ruleForm.pass)
						}),
						{
							headers:{
								Authorization:token
							}
						},
					)
					.then(function(res){
						let resData=res.data;
						if(resData.code==0){
							//弹出即将退出登录的提示框
							that.$alert('修改密码成功，点击确定退出登录状态！！！', '信息提示', {
								confirmButtonText: '确定',
								callback: action => {
									that.$selfjs.loginOutFn(that, "location")
								}
							});
							that.$message.close();
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		//关闭
		before_close(done){
			this.$store.commit("get_is_expire", {
				is_expire:0,
				msg:''
			})
			done();
		},
	}

	,computed:{
		is_expire(){
			// return true
			if (this.$store.state.pwd_exp_check && this.$store.state.pwd_exp_check.is_expire==1) {
				return true
			}else{
				return false
			}
		}
	}
	,watch:{
		// muban_bol(o,n){
		// 	this.$forceUpdate()
		// }
	}
	,components:{
		headView
		,footerView
	}
}
</script>

<!-- scoped 单页面有效属性 -->
<style scoped>
#app{background:#f4f4f4;min-height:100vh;}
#app .load{position:fixed;left:0;top:0;width:100%;height:100%;z-index:9999;background:#fff;}
.tip{
	position: absolute;
    top: 53px;
    font-size: 12px;
	color: #999;
}
</style>


// WEBPACK FOOTER //
// src/App.vue